export default __webpack_public_path__ + "static/ai-caption-ce1c64412de1c52bbc1de808c9ff351f.mp4";